import { defineStore } from "pinia";

export const useClasseStore = defineStore('classe', {
    state: () => ({
        classe: {},
        classes: [],
    }),
    actions: {
        setClasse(classe) {
            this.classe = classe
        },
        setClasses(classes) {
            this.classes = classes
        },
        addClasse(classe) {
            this.classes.unshift(classe)
        },
        updateClasse(classe) {
            let index = this.classes.findIndex(cl => cl.id === classe.id)
            this.classes.splice(index, 1, classe)
        },
        deleteClasse(classe) {
            let index = this.classes.findIndex(cl => cl.id === classe.id)
            this.classes.splice(index, 1)
        },
    },
});